import { useRef, useMemo, useEffect } from 'react'
import { Sheet, SheetContent, SheetCustomContent } from '@sweetspot/scramble-ds'
import { DeviceType, useDeviceType } from '@sweetspot/scramble-ds/utils'
import SideNavItems from './SideNavItems'
import { useMobileSideBarStore } from '@sweetspot/club-portal-legacy/hooks/useMobileSideBarStore'
import { usePreventPointerDownIfInside } from '@sweetspot/club-portal-legacy/hooks/usePreventPointerDownIfInside'

const SideNav = ({ headerRef }) => {
  const sheetRef = useRef(null)
  const { isMobileSideBarOpen, toggleMobileSideBar } = useMobileSideBarStore()
  const { deviceType } = useDeviceType()

  const isMobile = useMemo(() => deviceType === DeviceType.MOBILE, [deviceType])

  const sideBarSize = useMemo(() => (isMobile ? 'large' : 'small'), [isMobile])

  const handlePointerDownOutside = usePreventPointerDownIfInside(headerRef)

  useEffect(() => {
    if (isMobile && isMobileSideBarOpen) {
      const targetEl = headerRef?.current
      if (!targetEl) return
      targetEl.style.pointerEvents = 'auto'
    }
  }, [headerRef, isMobile, isMobileSideBarOpen])

  if (isMobile) {
    return (
      <Sheet open={isMobileSideBarOpen} onOpenChange={toggleMobileSideBar}>
        <SheetContent
          ref={sheetRef}
          side="left"
          className={`top-[77px] max-h-[calc(100vh-77px)] w-[344px]`}
          overlayClassName="inset-x-0 top-[77px] max-h-[calc(100vh-77px)]"
          onPointerDownOutside={handlePointerDownOutside}
        >
          <SheetCustomContent className="p-0">
            <SideNavItems alwaysExpanded size={sideBarSize} />
          </SheetCustomContent>
        </SheetContent>
      </Sheet>
    )
  }

  return <SideNavItems size={sideBarSize} />
}

export default SideNav
